export default __webpack_public_path__ + "96c9cc51c0a1f3755fbf0bafd196cecd.png";